import request from "./request";

const api = {
  checkCode: "user_url/checkCode",
};
export default {
  checkCode(parameter) {
    return request({
      url: api.checkCode,
      method: "POST",
      data: parameter,
    });
  },

};
